import { hmac } from 'node-forge';

export interface IUserWorkspace<T extends string = string> {
  uid: string;
  workspace: string;
  type: T;
  /**
   * Human-readable name of the workspace. Optional as older function
   * deployments and non-organisation producers omit it.
   */
  name?: string;
}

export interface ICheckOrganisationExists {
  workspace: string;
}

export interface IAuthClaims {
  isManagement: boolean;
  orgUids: string[];
  enabledOrgUids: { [key: string]: boolean };
}

export const LAST_ACTIVE_SYNC_INTERVAL = 1000 * 60 * 60;

export class Auth {
  static encodeData(secretKey: string, data: string): string {
    const encoder: hmac.HMAC = hmac.create();
    encoder.start('sha256', secretKey);
    encoder.update(data);
    return encoder.digest().toHex();
  }
}
